import { FileSearch, User, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DemoModeSwitcher,
  type DemoMode,
} from "./DemoModeSwitcher";

const FEATURES = [
  {
    icon: User,
    text: "Создаёт профиль клиента на основе данных из открытых источников",
  },
  {
    icon: Zap,
    text: "Предоставляет менеджеру рекомендации в режиме реального времени",
  },
  {
    icon: FileSearch,
    text: "Анализирует запись встречи и оценивает работу сотрудника",
  },
] as const;

export type WelcomeEmptyStateProps = {
  demoMode: DemoMode;
  onDemoModeChange: (mode: DemoMode) => void;
  onStartTour: () => void;
  onRestartTour?: () => void;
  canResume?: boolean;
};

export function WelcomeEmptyState({
  demoMode,
  onDemoModeChange,
  onStartTour,
  onRestartTour,
  canResume = false,
}: WelcomeEmptyStateProps) {
  const showTourActions = demoMode === "tour";
  return (
    <div className="mx-auto flex h-full w-full max-w-250 p-4 md:p-6">
      <div className="flex w-full flex-1 items-center justify-center">
        <div className="flex w-full max-w-xl flex-col items-center gap-8 p-6">
          <DemoModeSwitcher
            value={demoMode}
            onValueChange={onDemoModeChange}
            variant="welcome"
          />

          <div className="flex w-full flex-col items-center gap-6">
            <div className="flex flex-col items-center gap-2 text-center">
              <h1 className="text-h2 font-medium text-neutral-text-900">
                Добро пожаловать в Sales Copilot
              </h1>
              <p className="text-body1 text-neutral-text-500">
                Sales Copilot помогает менеджеру на всех этапах встречи:
              </p>
            </div>

            <ul className="flex w-full max-w-md flex-col gap-4">
              {FEATURES.map(({ icon: Icon, text }) => (
                <li key={text} className="flex items-start gap-3">
                  <span className="flex size-10 shrink-0 items-center justify-center rounded-m bg-neutral-background-100 text-neutral-text-900">
                    <Icon className="size-5" aria-hidden />
                  </span>
                  <span className="pt-2 text-body1 text-neutral-text-800">
                    {text}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div
            className={
              showTourActions
                ? "flex flex-col items-center gap-3"
                : "invisible flex flex-col items-center gap-3"
            }
          >
            <Button
              type="button"
              variant="default"
              size="lg"
              tabIndex={showTourActions ? 0 : -1}
              onClick={onStartTour}
            >
              {canResume ? "Продолжить тур" : "Начать тур"}
            </Button>
            {canResume && onRestartTour ? (
              <Button
                type="button"
                variant="ghost"
                size="sm"
                tabIndex={showTourActions ? 0 : -1}
                onClick={onRestartTour}
              >
                Начать сначала
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
